import { VlRouteBase } from '@vuelib/components';

export default /** @type { import('vue-router').RouteConfig } */ ({
  path: 'companies',
  component: VlRouteBase,
  meta: {},
  children: [
    {
      path: '',
      name: 'companies',
      component: () => import(/* webpackChunkName: "companies" */ '@/views/companies/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support'],
      },
    },

    {
      path: ':companyId',
      name: 'companies.id',
      meta: {
        backTo: () => ({ name: 'companies' }),
        roles: ['admin', 'developer', 'support'],
      },
      component: () => import(/* webpackChunkName: "companies" */ '@/views/companies/_id.vue'),
    },

    {
      path: ':companyId/users',
      name: 'companies.id.users',
      meta: {
        backTo: () => ({ name: 'companies' }),
        roles: ['admin', 'developer', 'support'],
      },
      component: () => import(/* webpackChunkName: "companies.users" */ '@/views/companies/users/index.vue'),
    },

    {
      path: ':companyId/users/:userId',
      name: 'companies.id.users.id',
      meta: {
        backTo: ({ $route }) => ({ name: 'companies.id.users', params: $route.params }),
        roles: ['admin', 'developer', 'support'],
      },
      component: () => import(/* webpackChunkName: "companies.users" */ '@/views/companies/users/_id.vue'),
    },
  ],
});
